import React, { useRef, useEffect } from 'react';
import { pictureMapType } from './GlobalData';
import './ImageSet.css';

type imageElementRef = {
	image: HTMLElement;
	appended: boolean;
}

type imageElementRefsMapType = {
	[key:string]: imageElementRef;
};

type ImageSetProps = {
	currentImageRef: string;
	basePath: string;
	images: pictureMapType;
};

let imageElements:imageElementRefsMapType = {};

function ImageSet( {currentImageRef, basePath, images}: ImageSetProps) {
	
	useEffect( () => {
			let sortedImageKeys = Object.keys(images).sort();
			for(let x = 0, max = sortedImageKeys.length; x < max; x++) {
				let key = sortedImageKeys[x];
				imageElements[key] = { image: document.createElement('div'), appended: false };
				imageElements[key].image.classList.add('imageBase');
				if(imageElements[key] && x < 10) {
					imageElements[key].image.setAttribute('style','background-image: url("'+basePath+images[key]+'")');
					document?.getElementById('ImageSetContainer')?.append(imageElements[key].image);
					imageElements[key].appended = true;
				}
			}
	}, []);
	
	useEffect( () => {
		document.querySelectorAll('.imageActive').forEach( (elem) => elem.classList.remove('imageActive'));

		if(imageElements.hasOwnProperty(currentImageRef)) {
			if(imageElements[currentImageRef].appended === false) {
				imageElements[currentImageRef].image.setAttribute('style','background-image: url("'+basePath+images[currentImageRef]+'")');
				document?.getElementById('ImageSetContainer')?.append(imageElements[currentImageRef].image);
				imageElements[currentImageRef].appended = true;
			}
			imageElements[currentImageRef].image.classList.add('imageActive');
	}
	});

  return (
    <div id="ImageSetContainer" className="imageSetContainer">
		</div>
  );
}

export default ImageSet;
